import React, { FunctionComponent } from 'react';
import { Document, Page } from '@react-pdf/renderer';
import Context from '../Context';
import type { Job } from '../types';
import useRenderProps from './useRenderProps';
import { STYLES, SIZE, CREATOR } from './constants';
import Header from '~/hooks/useQuoteDownload/Render/Header';
import Title from '~/hooks/useQuoteDownload/Render/Title';
import LineItems from '~/hooks/useQuoteDownload/Render/LineItems';
import Totals from '~/hooks/useQuoteDownload/Render/Totals';

export interface RenderProps {
  job: Job | null;
}

const Render: FunctionComponent<RenderProps> = function (job) {
  const { title, author } = useRenderProps();

  const DocumentTag = Document as unknown as FunctionComponent<any>;
  const PageTag = Page as unknown as FunctionComponent<any>;

  return (
    <Context.Provider value={job}>
      <DocumentTag author={author} title={title} creator={CREATOR}>
        <PageTag size={SIZE} style={STYLES.page}>
          <Header />
          <Title />
          <LineItems />
          <Totals />
        </PageTag>
      </DocumentTag>
    </Context.Provider>
  );
};

export default Render;
